import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';
import { PaymentDerivedStatus } from '@fitness-force/enum';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BadgeModule } from 'primeng/badge';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'payment-timeline-status',
  templateUrl: './payment-timeline-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, BadgeModule, TranslateModule]
})
export class PaymentTimelineStatusComponent implements OnInit {
  @Input() additionData = new BehaviorSubject(null);
  @Input() columnData  = new BehaviorSubject(null);
  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

  public get paymentStatus()
  {
    return PaymentDerivedStatus;
  }

}